@if (control) {
<astral-field-shell
  [control]="control"
  [forId]="resolvedInputId"
  [helpText]="helpText"
  [label]="resolvedLabel"
  [readonly]="resolvedReadonly"
  [disabled]="resolvedDisabled"
  [required]="resolvedRequired"
  [errorMessage]="errorMessage"
  [invalid]="invalid"
>
  <input
    astralFieldAccessibility
    astralTemporalInput="time"
    [astralFieldControl]="control"
    [astralFieldHelpText]="helpText"
    [astralFieldInputId]="resolvedInputId"
    [astralFieldInvalid]="invalid"
    [astralFieldRequired]="resolvedRequired"
    [attr.id]="resolvedInputId"
    class="astral-time-picker"
    type="time"
    step="60"
    [attr.autocomplete]="autocomplete"
    [readonly]="resolvedReadonly ? true : null"
    [disabled]="resolvedDisabled ? true : null"
    [required]="resolvedRequired ? true : null"
    [value]="control.value || ''"
    [attr.name]="resolvedInputName"
    (focus)="handleFocus()"
    (input)="handleTimeChange($any($event.target).value)"
    (astralTemporalInputCommit)="handleTimeChange($event)"
    (blur)="handleBlur()"
  />
</astral-field-shell>
}
